import React from 'react';
import { IconPackageOpen } from '@sfx/icons';
import { getTransFunc } from '../../SFxLocalization';
var prefix = 'sfx-react-ui';

function NoData(props) {
  var transInstance = props.transInstance;
  var trans = getTransFunc(transInstance);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-table-noData")
  }, /*#__PURE__*/React.createElement(IconPackageOpen, {
    size: 55
  }), trans('SFxTableNoData'));
}

export default NoData;